import { motion } from "framer-motion";
import { Banknote, PoundSterling } from "lucide-react";
import SceneShell from "../components/SceneShell";

/**
 * Scene 22b — Section 5 pre-title · "Show me the money!"
 * Sits between Scene22 (What this means) and Scene23 (Baseline current).
 * Sets up the commercials section with playful energy.
 */

export default function SceneShowMeTheMoney() {
  return (
    <SceneShell variant="ink" align="center" data-testid="scene-show-me-money">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at center, rgba(150,193,31,0.16) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(150,193,31,0.32) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(150,193,31,0.16) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Floating £ glyphs in the background */}
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <motion.span
          key={i}
          className="absolute pointer-events-none kn-display"
          style={{
            color: "rgba(150,193,31,0.18)",
            fontSize: 64 + (i % 3) * 32,
            fontWeight: 900,
            top: `${10 + (i * 13) % 70}%`,
            left: `${(i * 17 + 5) % 90}%`,
          }}
          animate={{
            y: [0, -20, 0],
            opacity: [0.18, 0.45, 0.18],
            rotate: [0, 8, 0],
          }}
          transition={{
            duration: 7 + i,
            repeat: Infinity,
            delay: i * 0.6,
            ease: "easeInOut",
          }}
        >
          £
        </motion.span>
      ))}

      <div className="relative max-w-[1500px] mx-auto w-full text-center">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="kn-eyebrow mx-auto flex items-center justify-center gap-2"
        >
          <PoundSterling className="w-3.5 h-3.5" style={{ color: "#96C11F" }} />
          Section opener
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, scale: 0.85, filter: "blur(20px)" }}
          animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          transition={{ duration: 1.4, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display leading-[0.92]"
          style={{
            fontSize: "clamp(72px, 12vw, 180px)",
            color: "#e2e8f0",
            fontWeight: 900,
            marginTop: 36,
          }}
          data-testid="show-me-money-title"
        >
          Show me the{" "}
          <span
            style={{
              background:
                "linear-gradient(135deg, #96C11F 0%, #00deb6 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              textShadow: "0 0 80px rgba(150,193,31,0.45)",
            }}
          >
            money!
          </span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.0, delay: 1.2 }}
          className="mt-10 inline-flex items-center gap-3 rounded-full px-7 py-3 glass-dark"
          data-testid="show-me-money-subtitle"
        >
          <Banknote className="w-4 h-4" style={{ color: "#96C11F" }} />
          <span
            className="text-sm sm:text-base tracking-[0.18em] uppercase"
            style={{ color: "rgba(255,255,255,0.85)", fontWeight: 700 }}
          >
            Time for some commercials.
          </span>
        </motion.div>
      </div>
    </SceneShell>
  );
}
